import axios from 'axios'
import router from "@/router/index";
import store from "./../store/index";

let Api = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

Api.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('access_token')

        if (token) {
            config.headers['Authorization'] = token
        }

        return config
    },
  
    (error) => {
        return Promise.reject(error)
    }
)

Api.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        store.dispatch("authentication/logoutAux", null, { root: true });
          return null
      }
      return Promise.reject(error);
    }
  );

export default Api;